import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Accordion,
  AccordionSet,
  FilterAccordionHeader,
} from '@folio/stripes/components';
import { CheckboxFilter } from '@folio/stripes/smart-components';

const PREFIX = 'scheduled-reports-filter';

function ScheduledReportsFilters({ activeFilters = {}, onChangeHandlers, resultOffset }) {
  const intl = useIntl();

  const handleChange = (filter) => {
    if (resultOffset) resultOffset.replace(0);
    onChangeHandlers.state({ ...activeFilters, [filter.name]: filter.values });
  };

  const handleClear = (name) => {
    if (resultOffset) resultOffset.replace(0);
    onChangeHandlers.clearGroup(name);
  };

  const { isActive = [], frequency = [], outputFormat = [] } = activeFilters;

  const activeOptions = [
    { value: 'true',  label: intl.formatMessage({ id: 'ui-reports.scheduledReports.active' }) },
    { value: 'false', label: intl.formatMessage({ id: 'ui-reports.scheduledReports.paused' }) },
  ];

  const frequencyOptions = [
    { value: 'once',    label: intl.formatMessage({ id: 'ui-reports.scheduledReports.frequency.once' }) },
    { value: 'hourly',  label: intl.formatMessage({ id: 'ui-reports.scheduledReports.frequency.hourly', defaultMessage: 'Hourly' }) },
    { value: 'daily',   label: intl.formatMessage({ id: 'ui-reports.scheduledReports.frequency.daily' }) },
    { value: 'weekly',  label: intl.formatMessage({ id: 'ui-reports.scheduledReports.frequency.weekly' }) },
    { value: 'monthly', label: intl.formatMessage({ id: 'ui-reports.scheduledReports.frequency.monthly' }) },
    { value: 'yearly',  label: intl.formatMessage({ id: 'ui-reports.scheduledReports.frequency.yearly' }) },
    { value: 'custom',  label: intl.formatMessage({ id: 'ui-reports.scheduledReports.frequency.custom' }) },
  ];

  const formatOptions = [
    { value: 'excel', label: intl.formatMessage({ id: 'ui-reports.outputFormat.excel' }) },
    { value: 'pdf',   label: intl.formatMessage({ id: 'ui-reports.outputFormat.pdf' }) },
    { value: 'csv',   label: intl.formatMessage({ id: 'ui-reports.outputFormat.csv' }) },
    { value: 'json',  label: intl.formatMessage({ id: 'ui-reports.outputFormat.json' }) },
  ];

  return (
    <AccordionSet>
      <Accordion
        displayClearButton={isActive.length > 0}
        id={`${PREFIX}-isActive`}
        header={FilterAccordionHeader}
        label={<FormattedMessage id="ui-reports.scheduledReports.status" />}
        separator={false}
        onClearFilter={() => handleClear('isActive')}
      >
        <CheckboxFilter
          dataOptions={activeOptions}
          name="isActive"
          selectedValues={isActive}
          onChange={handleChange}
        />
      </Accordion>

      <Accordion
        displayClearButton={frequency.length > 0}
        id={`${PREFIX}-frequency`}
        header={FilterAccordionHeader}
        label={<FormattedMessage id="ui-reports.scheduledReports.frequency" />}
        separator={false}
        onClearFilter={() => handleClear('frequency')}
      >
        <CheckboxFilter
          dataOptions={frequencyOptions}
          name="frequency"
          selectedValues={frequency}
          onChange={handleChange}
        />
      </Accordion>

      <Accordion
        displayClearButton={outputFormat.length > 0}
        id={`${PREFIX}-outputFormat`}
        header={FilterAccordionHeader}
        label={<FormattedMessage id="ui-reports.scheduledReports.outputFormat" />}
        separator={false}
        onClearFilter={() => handleClear('outputFormat')}
      >
        <CheckboxFilter
          dataOptions={formatOptions}
          name="outputFormat"
          selectedValues={outputFormat}
          onChange={handleChange}
        />
      </Accordion>
    </AccordionSet>
  );
}

ScheduledReportsFilters.propTypes = {
  activeFilters: PropTypes.object,
  onChangeHandlers: PropTypes.object.isRequired,
  resultOffset: PropTypes.shape({ replace: PropTypes.func.isRequired }),
};

export default ScheduledReportsFilters;
